import React from 'react'
import { M_CheckBox, M_DrawerTableTextField, M_InputTextField } from 'src/M_Components'

export const changes = (field, value, setData) => {
    setData(prev => ({ ...prev, [field]: value }))
}

export const ExchangeFormField = ({ code, type, entity, filterField, labelFields, extraFields, translateKey, label, required, index, data, setData, hideLabels, returnFunc, size }) => {
    if (type === 'disabled') {
        return (
            <div style={{ margin: '5px', width: 'auto' }} key={index}>
                <M_InputTextField
                    translate={translateKey}
                    size={size && size || '250px'}
                    disabled
                    label={hideLabels ? null : label}
                    value={data[code] || ''}
                />
            </div>
        )
    }

    if (type === 'date' || type === 'number' || type === 'text') {
        return (
            <div style={{ margin: '5px', minWidth: '50px', }} key={index}>
                <M_InputTextField
                    translate={translateKey}
                    size={size && size || '250px'}
                    label={hideLabels ? null : label}
                    type={type}
                    value={data && data[code] || ''}
                    required={hideLabels ? null : required && required || false}
                    color={required && !data[code] && 'var(--color-red)'}
                    secondColor={required && !data[code] && 'var(--color-red)'}
                    onChange={(e) => {
                        if (returnFunc) {
                            returnFunc(data, e.target.value)
                            return
                        }
                        changes(code, e.target.value, setData)
                    }}
                    // submit={submit}
                    // cancel={cancel}
                />
            </div>
        )
    }

    if (type === 'foreignKey') {
        return (
            <div style={{ margin: '5px', width: 'auto' }} key={index}>
                <M_DrawerTableTextField
                    translate={translateKey}
                    size={size && size || '250px'}
                    style={{ maxWidth: '250px' }}
                    tableLabel={entity}
                    label={hideLabels ? null : label}
                    entity={entity}
                    filterField={filterField}
                    labelFields={labelFields}
                    value={data && data[code] ?
                        Object.assign({}, ...extraFields?.map(obj => ({ [obj.key]: data[obj.value] })))
                        : null}
                    onSubmitValue={(obj => {
                        if (returnFunc) {
                            returnFunc(data, obj)
                            return
                        }
                        extraFields?.map(keyValue => {
                            changes(keyValue.value, obj && obj[keyValue.key] || '', setData)
                        })
                    })}
                    required={hideLabels ? null : required && required || false}
                    color={required && !data[code] && 'var(--color-red)'}
                    secondColor={required && !data[code] && 'var(--color-red)'}

                />
            </div>
        )
    }

    if (type === 'checkBox') {
        return (
            <div style={{ margin: '5px', width: 'auto' }} key={index}>
                <M_CheckBox
                    translate={translateKey}
                    required={hideLabels ? null : required && required || false}
                    label={hideLabels ? null : label}
                    checked={data[code] || false}
                    onChange={(e) => {
                        if (returnFunc) {
                            returnFunc(data, code, e.target.checked)
                            return
                        }
                        changes(code, e.target.checked, setData)
                    }}
                />
            </div>
        )
    }

    if (type === 'whitespace') {
        return (
            <div style={{ margin: '5px' }} key={index}></div>
        )
    }
}

